export default __webpack_public_path__ + "favicon.ico?44c0126ce39fc93663e3e3465d8f1755";